import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { goLiveIpo } from "../../store/actions/ipos/goLiveIpo";
import { getCurrencySymbol } from "../../Helper/getCurrencySymbol";

function GoLiveIpoModal({ open, onClose, ipo }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.ipos?.goLivePending);
  const [currentPrice, setCurrentPrice] = useState("");
  const [availableVolume, setAvailableVolume] = useState("");

  useEffect(() => {
    if (open) {
      setCurrentPrice(ipo?.offer_price ?? "");
      setAvailableVolume("");
    }
  }, [open, ipo]);

  const handleGoLive = () => {
    const data = {};
    if (currentPrice !== "") data.current_price = Number(currentPrice);
    if (availableVolume !== "") data.available_volume = Number(availableVolume);
    dispatch(goLiveIpo({ id: ipo?.id, data, callback: onClose }));
  };

  const symbol = getCurrencySymbol(ipo?.currency);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          maxWidth: "95vw",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">
            List {ipo?.stock?.symbol || "Offer"} as a Stock
          </h1>
          <p className="text-sm mb-4 text-[#475467]">
            Activates the stock so any user can trade it, seeds its price band
            from the opening price, and notifies every allotted subscriber.
          </p>
          <div className="text-xs text-[#B54708] bg-[#FFFAEB] border border-[#FEDF89] rounded-lg p-3 mb-6">
            This cannot be undone. Apply allotment results before listing —
            subscribers not yet allotted will not receive the listing
            notification.
          </div>

          <label className="text-sm font-[500]">
            Opening Price ({symbol})
          </label>
          <input
            type="number"
            value={currentPrice}
            onChange={(e) => setCurrentPrice(e.target.value)}
            placeholder={`Defaults to the offer price (${symbol} ${
              ipo?.offer_price ?? "-"
            })`}
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none"
          />

          <label className="text-sm font-[500]">Available Volume</label>
          <input
            type="number"
            value={availableVolume}
            onChange={(e) => setAvailableVolume(e.target.value)}
            placeholder="Leave blank to keep the stock's current cap"
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Go Live"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={loading}
              onClick={handleGoLive}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default GoLiveIpoModal;
